import React__default from "react";
import { AccordionItemContext } from "../accordion-item/accordion-item-context.mjs";
const AccordionContent = (props) => {
  const { collapseStyle, accordionRef, id, isOpen } = React__default.useContext(AccordionItemContext);
  const inertAttr = { inert: !isOpen ? "" : void 0 };
  return /* @__PURE__ */ React__default.createElement("div", { className: "accordion__border" }, /* @__PURE__ */ React__default.createElement("div", { className: "accordion__body", style: collapseStyle, ref: accordionRef }, /* @__PURE__ */ React__default.createElement("div", { className: "accordion__content", id, "aria-labelledby": "".concat(id, "-title"), ...inertAttr }, props.children)));
};
export {
  AccordionContent
};
